import { render, staticRenderFns } from "./SfMegaMenuColumn.vue?vue&type=template&id=04168e36&"
import script from "./SfMegaMenuColumn.vue?vue&type=script&lang=js&"
export * from "./SfMegaMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports